<template>
  <div class="row-content" style="padding: 1.25rem;font-size:12px ;" >
    <div class="row-title">评定结果 <span v-if="expertAuditScore">（{{expertAuditScore | formatestar}}）</span></div>
    <div class="stars_evalua-root">
      <ul class="stars">
        <li class="not_edit" v-for="(item,index) in starsList" :key="index" >
          <v-icon class="icon" v-if="item.checked" name="star" scale="2.8"></v-icon>
          <v-icon class="icon" v-else name="regular/star" scale="2.8"></v-icon>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import "vue-awesome/icons/star"
  import "vue-awesome/icons/regular/star"
  export default {
    props: {
      expertAuditScore: {
        type: Number,
        required: true,
        default : 0
      }
    },
    computed: {
      // 显示空的星星
//      starsList() {
//        console.log(this.expertAuditScore);
//        return Array(5)
//        .fill(null)
//        .map((item,i) => ({ checked: (i + 1 <= this.expertAuditScore) }));
//      },
//      // 不显示空的星星
      starsList() {
        console.log(this.expertAuditScore)
        return Array(this.expertAuditScore)
        .fill(null)
        .map(() => ({ checked: true }));
      }
    },
    data() {
      return {
        loading: false,
      };
    },

    methods: {

    },
    filters: {
      formatestar(val) {
        let res = '';
        switch (val.toString()) {
          case '1' : res = '一星'; break
          case '2' : res = '二星'; break
          case '3' : res = '三星'; break
          case '4': res = '四星'; break
          case '5': res = '五星'; break
        }
        return res;
      },
    }
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable1'

  .row-content
    position absolute
    top -4rem
    right -1.5rem
    bottom -0.875rem
    left -5.5rem
    padding 1.25rem 2rem
  .row-title
    color #68d8fe
    font-weight 600
    font-size 16px
    margin-bottom 0.4rem
    display flex
    align-items center
  .stars_evalua-root
    color $rating_primary_color
  // display inline-block
    .stars
      display flex
      justify-content center
      margin-bottom 13px
      .star
        cursor pointer
        &.not_edit
          cursor auto
        .icon
          display block
    .rating-desc
      display block
      font-size 20px
      text-align center
</style>
